import FileRoute from './_config/portail.file.routes';
import fileList from './components/file-list';

const moduleName = 'app.massia.common.portail.file';

angular.module(moduleName, []).config(FileRoute).component('portailFileList', fileList);
export default moduleName;
